import request from '@/utils/request'

//登录
export function login(data) {
  return request({
    url: '/bbsUserAuth/bbsLogin',
    method: 'post',
    data
  })
}
// 退出登录
export function logOut() {
  return request({
    url: '/bbsUserAuth/bbsLogOut',
    method: 'post'
  })
}
// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/auth/userInfo',
    method: 'get'
  })
}
//刷新token
export function refreshToken() {
  return request({
    url: '/bbsUserAuth/refreshBbsToken',
    method: 'post'
  })
}
// 获取所有部门信息
export function getAllGroup() {
  return request({
    url: '/group/selectAllGroup',
    method: 'get'
  })
}
// 修改用户信息
export function updateBbsUser(data) {
  return request({
    url: '/bbsUser/update',
    method: 'post',
    data
  })
}
// 发送登录验证码
export function sendAuthCode(data) {
  return request({
    url: '/bbsUserAuth/sendAuthCode',
    method: 'post',
    data
  })
}
// 验证码登录
export function verifyAuthCode(data) {
  return request({
    url: '/bbsUserAuth/verifyAuthCode',
    method: 'post',
    data
  })
}
// 设置密码
export function setPassword(data) {
  return request({
    url: '/bbsUserAuth/setPassword',
    method: 'post',
    data
  })
}
// 修改密码
export function updatePassword(data) {
  return request({
    url: '/bbsUserAuth/updatePassword',
    method: 'post',
    data
  })
}
